import { useState } from 'react';
import { ink } from '../lib/theme';
import { AuditExportModal } from './AuditExportModal';
import { IconUpload } from './icons';
import { originFrom, type Origin } from './ScaleModal';

/**
 * Botão de exportar auditoria pro pipeline da Nekt — só admin (a rota exige
 * `requireAdmin`; escondê-lo pra member evita um 403 confuso, mas o gate
 * real é sempre o backend). Discreto de propósito (ícone + rótulo curto,
 * sem badge/valor) — diferente do `RecoveredButton` (destaque positivo), este
 * é uma ação administrativa pontual, não um número pra acompanhar sempre.
 */
export function AuditExportButton({ period }: { period: { from?: string; to?: string } }) {
  const [origin, setOrigin] = useState<Origin | null>(null);
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={(e) => { setOrigin(originFrom(e)); setOpen(true); }}
        title="Exportar auditoria do período pro pipeline da Nekt"
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 7, border: `1px solid ${ink(0.14)}`,
          background: ink(0.05), borderRadius: 99, padding: '7px 14px 7px 12px', cursor: 'pointer',
          font: 'inherit', color: ink(0.62), transition: 'background 0.2s ease, color 0.2s ease, border-color 0.2s ease',
        }}
      >
        <IconUpload size={14} />
        <span style={{ fontSize: 12, fontWeight: 700 }}>Exportar</span>
      </button>

      <AuditExportModal open={open} origin={origin} onClose={() => setOpen(false)} period={period} />
    </>
  );
}
